module.exports = __webpack_public_path__ + "static/media/color_blind_image_10.78c0d49e.jpg";